import { useEffect, useState } from "react";
import { IExpenseRecord } from "../../../lib/types";
import { formatToEuro } from "../../../lib/utils";
import ExpenseItem from "./ExpenseItem";
import Button from "../../form/button";
import React from "react";
import Loading from "../../Loading";

interface ExpenseOverviewProps {
    expenses?: IExpenseRecord[];
    reload?: () => void;
    editable?: boolean;
    loading?: boolean;
}
export default function ExpenseOverview({ expenses, reload, editable = true, loading }: ExpenseOverviewProps) {
    const [totalPrice, setTotalPrice] = useState<number>(0);
    const perPage = 20;
    const [amount, setAmount] = useState(perPage);

    useEffect(() => {
        const calculatedTotalPrice = expenses?.reduce((total, expense) => {
            if (expense.income) return total + expense.amount * expense.price;
            else return total - expense.amount * expense.price;
        }, 0);

        setTotalPrice(calculatedTotalPrice || 0);
    }, [expenses]);

    function loadMore() {
        setAmount(amount + perPage);
    }

    return (
        <div className="my-8 grid grid-cols-12 gap-6">
            <div className="col-span-12 flex justify-end text-slate-500 @4xl:hidden">Total: {formatToEuro(totalPrice)}</div>
            <div className="col-span-12 flex flex-col gap-4 @4xl:col-span-7">
                {loading ? (
                    <div className="flex items-center justify-center">
                        <Loading />
                    </div>
                ) : (
                    <React.Fragment>
                        {expenses?.slice(0, amount).map((expense) => (
                            <ExpenseItem key={expense.id} expense={expense} editable={editable} reload={reload} />
                        ))}
                        {amount < (expenses?.length || 0) && (
                            <div className="flex w-full items-center justify-center">
                                <Button className="text-sm" onClick={loadMore} variant={"ghost"} size={"ghost"}>
                                    Load more
                                </Button>
                            </div>
                        )}
                    </React.Fragment>
                )}
            </div>
            <div className="hidden @4xl:col-span-5 @4xl:block">
                <div className="flex flex-col items-center rounded-lg border px-8 py-8">
                    <h2>Total expenses</h2>
                    {loading ? <Loading className="my-4" /> : <h3 className="my-4 text-3xl font-bold">{formatToEuro(totalPrice)}</h3>}
                </div>
            </div>
        </div>
    );
}
